import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

export function useShowSuggestedVictoriousPetitions(): boolean {
	const {
		data: {
			featureConfigs: { suggestedVictoriousPetitionsEnabled },
		},
	} = usePetitionDetailsPageData();

	return suggestedVictoriousPetitionsEnabled;
}
